<template>
	<ul class="menu">
		<li :class="[isAll?'active':'']" @click="toAll">
			<a href="javascript:;">全部</a>
		</li>
		<li :class="[!isAll&&(current==item.id)?'active':'']" @click="toDetail(item)" v-for="(item,index) in menuList" :key="item.id">
			<a href="javascript:;">{{item.categoryName}}</a>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'AsideNews',
		props: [
			"menuList"
		],
		data(){
			return {
				current: '',
				isAll: true
			}
		},
		methods: {
			toAll(){
				this.isAll = true
				this.current==''
				this.$emit('toList', {
					id: '',
					parentId: ''
				})
			},
			toDetail(item){
				this.isAll = false
				this.current = item.id
				this.$emit('toList', {
					id: item.id,
					parentId: item.parentId||''
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.menu{
		li{
			min-height: 44px !important;
			line-height: 44px;
			padding: 0 0 0 14px;
			a{
				color: rgba(0, 0, 0, .5)
			}
			cursor: pointer
		}
		li.active{
			background: rgba(222, 5, 21,.1);
			border-right: 4px solid #DE0515;
			color: #000
		}
	}
</style>
